import {
  TOGGLE_SRP_BUS_LOADING,
  UPDATE_SRP_BUS_DATA,
  UPDATE_RTC_VIEW,
  UPDATE_SORTBY,
  RESET_FILTERS,
  FILTER_COLLAPSE,
  UPDATE_ACTIVE_SEARCH_FILTER,
  UPDATE_SELECTED_FILTER,
  UPDATE_SELECTED_BUS,
  UPDATE_GO_SAFE_BANNER,
  UPDATE_ROUTE_ID,
  TOGGLE_ALTERNATE_ROUTE_PAGE,
  SET_NEXT_DAY_POPUP,
  SET_SRP_CARD_INDEX
} from './constants';
import {
  ITOGGLE_SRP_BUS_LOADING,
  IUPDATE_SRP_BUS_DATA,
  IUPDATE_RTC_VIEW,
  IUPDATE_SORTBY,
  IRESET_FILTERS,
  IFILTER_COLLAPSE,
  IUPDATE_ACTIVE_SEARCH_FILTER,
} from './validation';
export function toggleIsLoadingAction(
  actionData: ITOGGLE_SRP_BUS_LOADING['actionData'],
): ITOGGLE_SRP_BUS_LOADING {
  return {
    type: TOGGLE_SRP_BUS_LOADING,
    actionData,
  };
}

export function updateSRPBusData(
  actionData: IUPDATE_SRP_BUS_DATA['actionData'],
): IUPDATE_SRP_BUS_DATA {
  return {
    type: UPDATE_SRP_BUS_DATA,
    actionData,
  };
}
export function updateRTCView(actionData: IUPDATE_RTC_VIEW['actionData']): IUPDATE_RTC_VIEW {
  return {
    type: UPDATE_RTC_VIEW,
    actionData,
  };
}

export function updateSortBy(actionData: IUPDATE_SORTBY['actionData']): IUPDATE_SORTBY {
  return {
    type: UPDATE_SORTBY,
    actionData,
  };
}

export function resetFilters(actionData: IRESET_FILTERS['actionData']): IRESET_FILTERS {
  return {
    type: RESET_FILTERS,
    actionData,
  };
}

export function filterCollapse(actionData: IFILTER_COLLAPSE['actionData']): IFILTER_COLLAPSE {
  return {
    type: FILTER_COLLAPSE,
    actionData,
  };
}

export function updateActiveSearchFilter(
  actionData: IUPDATE_ACTIVE_SEARCH_FILTER['actionData'],
): IUPDATE_ACTIVE_SEARCH_FILTER {
  return {
    type: UPDATE_ACTIVE_SEARCH_FILTER,
    actionData,
  };
}


export function updateSelectedFilters(actionData:any){
  return {
      type:UPDATE_SELECTED_FILTER,
      actionData
  }
}
export function updateSelectedBus(actionData:string){
  return {
    type:UPDATE_SELECTED_BUS,
    actionData
  }
}
export function updateGoSafeBanner(actionData){
  return{
    type:UPDATE_GO_SAFE_BANNER,
    actionData
  }
}
export function updateRouteId(actionData:string){
  return{
    type:UPDATE_ROUTE_ID,
    actionData
  }
}
export function toggleAlternateRoutePage(actionData:boolean){
  return {
    type:TOGGLE_ALTERNATE_ROUTE_PAGE,
    actionData
  }
}


export function setNextDayPopup(actionData:boolean){
  return {
    type:SET_NEXT_DAY_POPUP,
    actionData
  }
}

export function setSrpCardIndex(actionData){
  return{
    type:SET_SRP_CARD_INDEX,
    actionData
  }
}